// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"e25cfb78","182":"76005cd0","291":"113964f3","358":"8072092c","369":"4e8a1d4b","394":"31d6cfe0","520":"50e7ad21","616":"3779d37d","687":"9236538e","844":"727fa8c6"}[chunkId] + ".chunk.css";
};